import * as React from 'react';
import { Button, Col, Row } from "react-bootstrap";
import { Pencil, Trash } from "react-bootstrap-icons";

import { Fermentable, fermentableTypeFriendlyString } from "@app/models/fermentable";
import "@app/assets/scss/components/IngredientsItem.scss"

interface Props {
    fermentable: Fermentable
    onClick: (fermentable: Fermentable) => void,
    onDelete: (fermentable: Fermentable) => void,
}

export class FermentableItemComponent extends React.Component<Props, Record<string,never>> {

    public constructor(props: Props) {
        super(props)
    }

    public onDeleteButton = (evt) => {
        if(this.props.onDelete) {
            this.props.onDelete(this.props.fermentable);
        }
    }

    public onClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
        const { onClick, fermentable } = this.props;
        onClick(fermentable);
    }

    public render() {
        const { fermentable } = this.props;

        return (
            <Row className="ingredientsRowItem" onClick={this.onClick}>
                <Col sm="4">
                    {fermentable.name}
                </Col>
                <Col sm="2">
                    {fermentableTypeFriendlyString(fermentable.fermentable_type)}
                </Col>
                <Col sm="1">
                    {fermentable.lovibond}
                </Col>
                <Col sm="1">
                    {fermentable.point_per_pound_gallon}
                </Col>
                <Col sm="1">
                    { fermentable.producer?.name ?? ""}
                </Col>
            </Row>
        );
    }
}